import axios from "axios";
import config from "../config/config";
import store from "../store"

const API_URL = config.API_URL; 

const buildOwnerFormData = (data, isUpdate = false) => {
    if (data instanceof FormData) {
        if (isUpdate && !data.has('_method')) {
            data.append('_method', 'PUT');
        }
        return data;
    }
    const payload = new FormData();
    const hasExplicitPlayers = data.numberOfPlayers !== undefined || data.number_of_players !== undefined;
    const mapped = {
        ...data,
        companyName: data.companyName ?? data.company_name ?? data.name ?? '',
        company_name: data.company_name ?? data.companyName ?? data.name ?? '',
        name: data.name ?? data.companyName ?? data.company_name ?? '',
        ownerName: data.ownerName ?? data.owner_name ?? '',
        owner_name: data.owner_name ?? data.ownerName ?? '',
        emailAddress: data.emailAddress ?? data.email_address ?? data.email ?? '',
        email_address: data.email_address ?? data.emailAddress ?? data.email ?? '',
        email: data.email ?? data.emailAddress ?? data.email_address ?? '',
        phoneNumber: data.phoneNumber ?? data.phone_number ?? '',
        phone_number: data.phone_number ?? data.phoneNumber ?? '',
        ...(hasExplicitPlayers || !isUpdate
            ? {
                  numberOfPlayers: data.numberOfPlayers ?? data.number_of_players ?? 100,
                  number_of_players: data.number_of_players ?? data.numberOfPlayers ?? 100,
              }
            : {}),
        ...(data.theme_color !== undefined ? { theme_color: data.theme_color } : {}),
        ...(data.welcome_message !== undefined ? { welcome_message: data.welcome_message } : {}),
        paymentStatus: data.paymentStatus ?? data.payment_status ?? (isUpdate ? undefined : 'paid'),
        payment_status: data.payment_status ?? data.paymentStatus ?? (isUpdate ? undefined : 'paid'),
        subscription: data.subscription ?? (isUpdate ? undefined : '1 Month'),
        package_id: data.package_id ?? (isUpdate ? undefined : 1),
    };
    Object.keys(mapped).forEach(key => {
        if (mapped[key] !== null && mapped[key] !== undefined && mapped[key] !== '') {
            payload.append(key, mapped[key]);
        }
    });
    if (data.companyLogo || data.company_logo || data.logo) {
        const logoFile = data.companyLogo || data.company_logo || data.logo;
        payload.append('company_logo', logoFile);
        payload.append('logo', logoFile);
    }
    if (isUpdate) {
        payload.append('_method', 'PUT');
    }
    return payload;
};

export const storeOwner = async (data) => {
    const token = store.state.authToken;
    const payload = buildOwnerFormData(data, false);
    const response = await axios.post(`${API_URL}company`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getOwner = async () => {
    const token = store.state.authToken;
    const response = await axios.get(`${API_URL}company`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response.data;
}

export const getDetailOwner = async (id) => {
    const token = store.state.authToken;
    const response = await axios.get(`${API_URL}company/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response.data;
}

export const updateOwner = async (id, data) => {
    const token = store.state.authToken;
    const payload = buildOwnerFormData(data, true);
    const response = await axios.post(`${API_URL}company/${id}?_method=PUT`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export const deleteOwner = async (id) => {
    const token = store.state.authToken;
    const response = await axios.delete(`${API_URL}company/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response.data;
}